import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ChannelsCommunities } from 'features/channels';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToJoinedCommunities } from '../hooks';

const PageChannelsCommunities = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const navigateToJoinedCommunities = useNavigateToJoinedCommunities();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <AppLayout>
      <ChannelsCommunities
        getPathToCommunityDetail={(id) => getPathToEntityDetail(id, { entityType: 'community' })}
        navigateToJoinedCommunities={navigateToJoinedCommunities}
        organizationId={organizationId}
      />
    </AppLayout>
  );
};

export default PageChannelsCommunities;
